import React, { FC } from "react";
// import { Link } from "react-router-dom";
import Icon from "../../components/icon/Icon";
import ComponyLogo from "../../assets/logos/phoenixLogo1.png";
// import ComponyLogo from "../../assets/logos/phoenixLogo.png";

interface IBrandProps {
  asideStatus: boolean;
  setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
  return (
    <div className="brand">
      <div className="brand-logo">
        <h1 className="brand-title ">
          <img src={ComponyLogo} className="w-100 h-100" alt="Company Logo" />
        </h1>
      </div>
      <button
        type="button"
        className="btn brand-aside-toggle"
        aria-label="Toggle Aside"
        onClick={() => setAsideStatus(!asideStatus)}
      >
        <Icon icon="FirstPage" className="brand-aside-toggle-close" />
        <Icon icon="LastPage" className="brand-aside-toggle-open" />
      </button>
    </div>
  );
};

export default Brand;
